import { useState, createContext, useContext, useRef, useEffect } from 'react'
import styles from './ManageSection.module.css'
import ProjectsTable from './ProjectsTable'
import ClientsTable from './ClientsTable'
import MembersTable from './MembersTable'
import GroupsTable from './GroupsTable'
import ImportSection from './ImportSection'

// Create context to track split view state
const SplitViewContext = createContext(false)

// Create context for data refresh events
const DataRefreshContext = createContext({
    triggerRefresh: () => {},
    refreshKey: 0
})

// Export contexts
export { SplitViewContext, DataRefreshContext }

export default function ManageSection({ activeSubSection, onSubSectionChange, selectedMemberId, selectedGroupId, selectedProjectId, apiToken, user }) {
    const [isInSplitView, setIsInSplitView] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0)

    // Function to trigger refresh across all manage tables
    const triggerRefresh = (source) => {
        console.log(`[ManageSection] Triggering refresh from ${source}`)
        setRefreshKey(prev => prev + 1)
    }

    const renderSubSectionContent = () => {
        const dataRefreshValue = { triggerRefresh, refreshKey }

        switch(activeSubSection) {
            case 'clients':
                return (
                    <DataRefreshContext.Provider value={dataRefreshValue}>
                        <SplitViewContext.Provider value={{ isInSplitView, setIsInSplitView }}>
                            <ClientsTable apiToken={apiToken} user={user} />
                        </SplitViewContext.Provider>
                    </DataRefreshContext.Provider>
                )
            case 'projects':
                return (
                    <DataRefreshContext.Provider value={dataRefreshValue}>
                        <SplitViewContext.Provider value={{ isInSplitView, setIsInSplitView }}>
                            <ProjectsTable apiToken={apiToken} selectedProjectId={selectedProjectId} />
                        </SplitViewContext.Provider>
                    </DataRefreshContext.Provider>
                )
            case 'groups':
                return (
                    <DataRefreshContext.Provider value={dataRefreshValue}>
                        <SplitViewContext.Provider value={{ isInSplitView, setIsInSplitView }}>
                            <GroupsTable
                                apiToken={apiToken}
                                selectedGroupId={selectedGroupId}
                                onSubSectionChange={onSubSectionChange}
                            />
                        </SplitViewContext.Provider>
                    </DataRefreshContext.Provider>
                )
            case 'members':
                return (
                    <DataRefreshContext.Provider value={dataRefreshValue}>
                        <SplitViewContext.Provider value={{ isInSplitView, setIsInSplitView }}>
                            <MembersTable
                                apiToken={apiToken}
                                user={user}
                                selectedMemberId={selectedMemberId}
                                onSubSectionChange={onSubSectionChange}
                            />
                        </SplitViewContext.Provider>
                    </DataRefreshContext.Provider>
                )
            case 'import':
                return (
                    <DataRefreshContext.Provider value={dataRefreshValue}>
                        <SplitViewContext.Provider value={{ isInSplitView, setIsInSplitView }}>
                            <ImportSection
                                apiToken={apiToken}
                                user={user}
                            />
                        </SplitViewContext.Provider>
                    </DataRefreshContext.Provider>
                )
            default:
                return (
                    <DataRefreshContext.Provider value={dataRefreshValue}>
                        <SplitViewContext.Provider value={{ isInSplitView, setIsInSplitView }}>
                            <ProjectsTable apiToken={apiToken} />
                        </SplitViewContext.Provider>
                    </DataRefreshContext.Provider>
                )
        }
    }

    return (
        <div className={styles.manageSection}>
            {/* Secondary Menu Bar */}
            <div className={styles.secondaryMenu}>
                <nav className={styles.subNav}>
                    <button
                        className={`${styles.subNavItem} ${activeSubSection === 'clients' ? styles.active : ''}`}
                        onClick={() => onSubSectionChange('clients')}
                    >
                        Clients
                    </button>
                    <button
                        className={`${styles.subNavItem} ${activeSubSection === 'projects' ? styles.active : ''}`}
                        onClick={() => onSubSectionChange('projects')}
                    >
                        Projects
                    </button>
                    <button
                        className={`${styles.subNavItem} ${activeSubSection === 'groups' ? styles.active : ''}`}
                        onClick={() => onSubSectionChange('groups')}
                    >
                        Groups
                    </button>
                    <button
                        className={`${styles.subNavItem} ${activeSubSection === 'members' ? styles.active : ''}`}
                        onClick={() => onSubSectionChange('members')}
                    >
                        Members
                    </button>
                    {(user?.workspace_role === 'admin' || true) && (
                        <button
                            className={`${styles.subNavItem} ${activeSubSection === 'import' ? styles.active : ''}`}
                            onClick={() => onSubSectionChange('import')}
                        >
                            Import
                        </button>
                    )}
                </nav>
            </div>

            {/* Sub-section Content */}
            <div className={`${styles.contentArea} ${isInSplitView ? styles.nopadding : ''}`}>
                {renderSubSectionContent()}
            </div>
        </div>
    )
}